import { formatPhoneNumber } from '@act/shared/utilities';
import { Box } from '@mui/material';
import { Fragment } from 'react';
import { LabeledDatum } from 'toolkit/styles/dataDisplay';

export interface ProviderEntryProps {
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
  phoneNumber: string;
}

const ProviderEntry = ({
  name,
  addressLine1,
  addressLine2,
  city,
  state,
  zip,
  phoneNumber,
}: ProviderEntryProps) => {
  return (
    <LabeledDatum
      label="Primary care physician"
      datum={
        <Fragment>
          <Box>
            {name && <Box>{name}</Box>}
            {addressLine1 && city && state && zip && (
              <Box>
                <Box>{addressLine1}</Box>
                {addressLine2 && <Box>{addressLine2}</Box>}
                <Box>
                  {city}, {state} {zip}
                </Box>
              </Box>
            )}
            {phoneNumber && <Box>{formatPhoneNumber(phoneNumber)}</Box>}
          </Box>
        </Fragment>
      }
    />
  );
};

export default ProviderEntry;
